/*
  自主/快速订单公用列表组件 
  
**/
<template>
  <div class="all_order_item">
    <!-- <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>-->
    <van-panel :class="item.mergeSendCode?'':'marbtn20'">
      <template #header>
        <div  class="lianmdiv"><img v-if="item.isJointlyBrand" class="img" :src="lianmurl" /><span v-if="item.isOutStock=='1'" class="no-product">缺货</span></div>
        <div class="panel van-hairline--bottom" @click="checkboxFun(item, cIndex)" >
          <div class="panel_header">
            <div style="width:20px">
              <van-checkbox
                v-if="yesPi"
                v-model="item.checked"
                class="check-button"
                icon-size="20"
                :checked-color="$theme.main_color_btn_bg">
              </van-checkbox> 
              <van-badge v-show="item.todayIncrNum && !yesPi" :content="item.todayIncrNum" :color="item.orderType == 'QUICK_ORDER' ? '#ED3939': '#F8A651'"/>
                <van-icon v-show="!item.todayIncrNum" name="orders-o" size="16" />
            </div>
            <p class="panel_header_title">
              {{item.subOrderCode}}
            </p>
            <div class="panel_header_time">
              <p class="panel_header_desc">{{item.createTime}}</p>
              <p class="panel_header_value">{{funStatus(item.orderStatus)}}</p>
            </div>
          </div>
          <div class="index-order-stock" v-if="item.supplierChannel==1">{{item.shippingWarehouseName}}</div>
        </div>
      </template>
      <template #footer v-if="isWebIM">
        <div class="webim-footer">
          <van-button
            v-if="item.orderStatus === 'GROUP_WAIT_SHARE' || (item.orderStatus == 'WAIT_SEND' && !item.isShowDelivery)"
            size="small"
            round
            normal
            hairline
            @click="openRemarkVisibleFun(item)"
          >备注</van-button>
        </div>
      </template>
      <template #footer v-else-if="item.shadowBranchIf == 1?false:true">
        <!-- {{mergeSendCode}} -->
        <!-- 主商品 与 赠品中有相同mergeSendCode字段则不展示商品的中操作按钮 -->
        <div class="footer" v-show="item.appOrderItemVoList && item.appOrderItemVoList[0] && item.appOrderItemVoList[0].isVirtual != 'y'&&  !mergeSendCode">
          <van-button
            class="div-btn-a w1 w3  print_btn"
            size="small"
              round
              normal
              hairline
              @click.stop="print_ticket(item)" :class="{'disabled':printTypeinfo==3||item.ticketId}" v-if="['WAIT_SEND','PRINTED','WAIT_RECEIVING','COMPLETED','WAIT_PRINT','PRINT_FAIL'].includes(item.orderStatus)&& isEnableTicket == '启用'"
          >
          <span v-if="printTypeinfo==1&&!item.ticketId">
              打印小票
            </span>
            <span v-else-if="printTypeinfo==2">
              打印中
            </span>
            <span v-else :printTypeinfo="3">
              已打印小票
            </span>
            
             <img v-if="printTypeinfo==2" src="https://img.chinabeego.com/uploadfile/2023/5/17/16843249059692059381552461341.png" alt="" srcset="" class="hold_on">
        </van-button>
          <!-- pointBranchBee 积分店铺蜜蜂帐号 -->
          <van-button
            class="div-btn-a w1 w3 "
            size="small"
            round
            normal
            hairline
            v-if="!item.pointBranchBee && (['PART_SEND','GROUP_WAIT_SHARE'].includes(item.orderStatus) || (item.orderStatus == 'WAIT_SEND' && !item.isShowDelivery))"
            @click="openRemarkVisibleFun(item)"
           
          >备注</van-button>
          <van-button
            class="div-btn-a w1 w3"
            size="small"
             round
              normal
              hairline
            v-if="!(item.supplierChannel == 1 && item.orderStatus == 'WAIT_SEND' && !item.isShowDelivery)"
            @click="contactFun(item.userId, item.shopId)"
          
          >联系客户</van-button>
          <span v-if="!item.pointBranchBee">
            <van-button
              class="div-btn-a w1 w3"
              size="small"
              round
                normal
                hairline
              v-if="funIsShowCancel(item)"
              @click="cancelShow = true"
            
            >取消揽件</van-button>
            <!-- ['PART_SEND','WAIT_SEND'].includes(item.orderStatus) -->
            <!-- 部分发货员工端不可发货 -->
            <van-button
              :class="[item.isShowSend || item.orderStatus == 'PART_SEND' ? 'color99':'button','div-btn-a','w1']"
              :color="item.isShowSend || item.orderStatus == 'PART_SEND' ?'#F2F2F2': ''"
              size="small"
              v-if="funIsShow(item) && item.dispatchType != 5"
              @click="goDetaiFun(item)"
            >发货</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              size="small"
              v-if="!item.pointBranchBee && funIsShowafter(item)"
              @click="toAfterInfo"
            >处理售后</van-button>
            <van-button
              :loading="repeaGetPowerLoading"
              class="button color33 div-btn-a w1"
              size="small"
              v-if="!item.actualAfter && item.orderStatus == 'PRINT_FAIL'"
              @click="repeaGetPowerFun(item.id)"
            >重新打印</van-button>
            <van-button
              :loading="repeaGetPowerLoading"
              class="button color33 div-btn-a w1"
              size="small"
              v-if="item.dispatchType == 3 && item.orderStatus == 'WAIT_RECEIVING' && item.dispatchType != 5"
              @click="reprintExpressBill(item.id)"
            >重打快递单</van-button>
            <van-button
              :loading="repeaGetPowerLoading"
              class="button color33 div-btn-a w1"
              size="small"
              v-if="item.isAllowConfirmDelivery && (item.orderStatus == 'WAIT_PRINT' || item.orderStatus == 'PRINT_FAIL') && item.dispatchType != 5"
              @click="onConfirmShipment(item.id)"
            >确认发货</van-button>
            <van-button
              :class="[item.isShowSend ? 'color99':'button','div-btn-a','w1']" 
              :color="item.isShowSend ?'#F2F2F2': ''"
              size="small"
              v-if="!(item.pushButtonStatus==2 || item.pushButtonStatus==4) && funIsShowExpress(item) && item.dispatchType != 5"
              @click="getTwoCodeFun(item)"
            ><span style="font-weight:bold">快递码</span></van-button>
            <van-button
              :class="[item.isShowSend || item.orderStatus == 'PART_SEND' ? 'color99':'button','div-btn-a','w1']" 
              :color="item.isShowSend || item.orderStatus == 'PART_SEND' ?'#F2F2F2': ''"
              size="small"
              v-if="!(item.pushButtonStatus==2 || item.pushButtonStatus==4) && funIsShowExpressSend(item) && item.dispatchType != 5"
              @click="openFun(item, '0')"
            >快递码</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              style="padding: 0;"
              size="small"
              v-if="item.pushButtonStatus==1 && funIsShowExpressCode(item) && item.dispatchType != 5"
              @click="sendExpressCode(item)"
            >推送快递码</van-button>
            <van-button
              class="color33 div-btn-a w1"
              style="button padding: 0;"
              size="small"
              v-if="item.pushButtonStatus==3 && funIsShowExpressCode(item)"
              @click="sendExpressCode(item)"
            >推送失效</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              style="padding: 0;"
              size="small"
              v-if="(item.pushButtonStatus==2 || item.pushButtonStatus==4) && funIsShowExpressCode(item)"
              @click="sendExpressCode(item)"
            >取消推送</van-button>
            <van-button
              :class="[item.isShowSend || item.orderStatus == 'PART_SEND' ? 'color99':'button','div-btn-a','w1']  " 
              :color="item.isShowSend || item.orderStatus == 'PART_SEND' ?'#F2F2F2': ''"
              size="small"
              v-if="funIsShowSelfPrintSend(item) && item.dispatchType != 5"
              @click="openFun(item, '1')"
            >自行打印</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              size="small"
              :class="[item.orderStatus == 'PART_SEND' ? 'color99':'button','div-btn-a','w1']  " 
              :color="item.orderStatus == 'PART_SEND' ?'#F2F2F2': ''"

              v-if="funIsShowPickingSend(item) && item.dispatchType != 5"
              @click="openFun(item, '2', 0)"
            >拣货单</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              size="small"
              v-if="funIsShowPicking(item) && item.dispatchType != 5"
              @click="checkPickingOnceFun(item)"
            >拣货单</van-button>
            <van-button
              :class="[item.isShowSend ? 'color99':'button','div-btn-a','w1']" 
              :color="item.isShowSend ?'#F2F2F2': ''"
              size="small"
              v-if="funIsShowPickingThree(item) && item.dispatchType != 5"
              @click="getTwoCodeFun(item, 1)"
            >快递码</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              size="small"
              v-if="funIsShowKCOne(item)"
              @click="handlerMaineOne(item)"
            >线下入机</van-button>
            <van-button
              class="button color33 div-btn-a w2"
              size="small"
              v-if="funIsShowKCTwo(item)"
              :loading="machineTwoLoading"
              @click="handlerMachineTwo(item)"
            >二维码入机</van-button>
            <van-button
              class="button color33 div-btn-a w2"
              size="small"
              v-if="item.orderStatus == 'WAIT_SEND' && item.dispatchType == 5"
              @click="mentionClick(item)"
            >确认有货可自提</van-button>
            <van-button
              class="button color33 div-btn-a w1"
              size="small"
              v-if="item.orderStatus == 'WAIT_RECEIVING' && item.dispatchType == 5"
              @click="mentionVerification"
            >核 销</van-button>
            <!-- <van-button
              class="color33 div-btn-a w1"
              class="button"
              size="small"
              v-if="funIsShowKCThree(item)"
              :loading="machineThreeLoading"
              @click="handlerMaineThree(item)"
            >重打小票</van-button> -->
            <!-- 增加发起退款  待发货显示 -->
            <!-- <van-button 
              class="color33 div-btn-a w2"
              class="button"
              size="small"
              v-if="item.orderStatus == 'WAIT_SEND'"
              :loading="machineTwoLoading"
              @click="getrefund(item)"
            >发起退款</van-button> -->
          </span>

        </div>
        <div class="footer" v-show="item.appOrderItemVoList && item.appOrderItemVoList[0] && item.appOrderItemVoList[0].isVirtual != 'y' && mergeSendCode">
          <van-button
            class="div-btn-a w1 w3  print_btn"
            size="small"
              round
              normal
              hairline
              @click.stop="print_ticket(item)" :class="{'disabled':printTypeinfo==3||item.ticketId}" v-if="['WAIT_SEND','PRINTED','WAIT_RECEIVING','COMPLETED','WAIT_PRINT','PRINT_FAIL'].includes(item.orderStatus)&& isEnableTicket == '启用'"
          >
          <span v-if="printTypeinfo==1&&!item.ticketId">
              打印小票
            </span>
            <span v-else-if="printTypeinfo==2">
              打印中
            </span>
            <span v-else :printTypeinfo="3">
              已打印小票
            </span>
            
             <img v-if="printTypeinfo==2" src="https://img.chinabeego.com/uploadfile/2023/5/17/16843249059692059381552461341.png" alt="" srcset="" class="hold_on">
        </van-button>
        </div>
        <div class="footer-wrap__kc100" v-if="item.orderStatus == 'WAIT_SEND' && item.supplierChannel == 1">
          <div class="kc_text">
            <img class="footer-wrap__kc100--picture" src="@/assets/order/kc100_house--icon.png" />
            <span class="footer-wrap__kc100--name">库存100发货单</span>
          </div>
          <div>
            <van-button
              v-if="item.chargebackType === 1"
              class="div-btn-a w1"
              size="small"
              plain
              @click="goDetaiFun(item)"
              color="#999999"
            >
              退单处理
            </van-button>
            <van-button
              class="div-btn-a w1 w3"
              size="small"
              plain
              @click="contactFun(item.userId, item.shopId)"
              color="#999999"
            >
              联系客户
            </van-button>
          </div>
        </div>
      </template>
      <div  class="shadow-page">
        <!-- <div class="shop-page">
          <van-icon name="shop-o" size="20px"/>
          <strong class="shop_title">{{ item.shopName }}</strong>
        </div> -->
        <div class="shadow_centent" v-if="item.shadowBranchName">
          <div class="shadow_tag">
            影子店铺
          </div>
          <div class="shadow_name">
            {{item.shadowBranchName}}
          </div>
          <div class="shadow_bgc">

          </div>
        </div>
      </div>
      
      <div class="order_page" v-if="item.appOrderItemVoList.length==1" @click="goDetaiFun(item,'showsend')">
        <div v-if="item.supplierChannel == 1" class="van-cell van-panel__header index-order">
          <div class="index-order-store">
            <van-icon class="van-icon van-icon-shop-o van-cell__left-icon" name="shop-o" />
            <span class="te">{{item.shopName}}</span>
          </div>
        </div>
        <div class="order_item" v-for="(t,idx) in item.appOrderItemVoList" :key="idx">
          <div class="order_info">
            <div class="img">
              <van-image
                :src="t.skuImageKey+'?x-oss-process=style/style_myorder_list_img'"
                fit="cover"
              />
              <div class="zen" style="left: 0px;" v-if="item.isGift">赠品</div>
              <div
                v-if="t.groupPeopleNum"
                class="group-buying-people-label"
                :style="{backgroundColor: t.groupBgColor, color: t.groupTextColor}"
              >{{t.groupPeopleNum}}人团</div>
            </div>
            <div class="info">
              <div class="infop1">
                <strong>{{funSubstring(t.goodsName)}}</strong>
              </div>
              <p class="attr flex_wrap flex-center">
                <span>{{t.beeAttributeValues}}</span>
                <span class="abnor_info" v-if="item.orderStatus == 'WAIT_SEND' && item.urgeOrder && item.urgeOrder.urgeId">
                  客户催发货x{{item.urgeOrder.urgeCount}}
                </span>
              </p>
              <p class="attr attr_padd flex_wrap flex-center">
                <span >
                  <div class="member_price_identification" :style="{ 'color': t.vipPriceWordTextColor, 'background-color': t.vipPriceWordBgColor }" v-if="t.vipAdjustFlag">
                    <span>{{ t.vipPriceGlobalWord }}</span>
                    <div class="triangle" :style="{'border-top': `6px solid ${t.vipPriceWordBgColor}`}"></div>
                  </div>
                  
                  <span v-if="item.buyType == 2" class="goodsPoint">{{t.exchangePoint}}积分</span>
                  <span v-else-if="item.buyType == 3" class="goodsPoint ">
                    <span>{{t.exchangePoint}}</span> 积分 + <span>{{t.goodsPrice}}</span> 元
                  </span>
                  <span v-else class="goodsPrice" v-price="t.goodsPrice"></span>
                </span>
                <span class="red" v-show="item.afterSaleInfo">{{item.afterSaleInfo}}</span>
              </p>
              <div class="attr" >
                <!-- <div v-show="t.itemCode">商品编码：{{t.itemCode}}</div> -->
                <div v-show="t.goodsCode" class="goods-code">商品货号：{{t.goodsCode}}</div>
                <div v-show="t.skuCode" class="goods-code">规格编码：{{t.skuCode}}</div>
                <div v-show="t.internationalGoodsCode" class="goods-code">国际编码：{{t.internationalGoodsCode}}</div>
                <div v-show="isPower['CASHIER_SYSTEM_INPUT'] && item.orderStatus == 'WAIT_SEND' && familiesPassStatus == '1' && item.familiesPassStatusCN" class="ke">{{item.familiesPassStatusCN}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order_item flex_wrap" v-else @click="goDetaiFun(item,'showsend')">
        <div class="order_info_left">
          <div class="order_info_img order_page">
            <van-image
              v-for="(t,idx) in item.appOrderItemVoList"
              :key="idx"
              :src="t.skuImageKey+'?x-oss-process=style/style_myorder_list_img'"
              width="70"
              height="70"
              fit="cover"
            />
            <!-- <template v-if="item.subOrderList" v-for="(t,idx) in item.subOrderList"> -->
              <!-- :style="idx==0?'left:0px;':'left:'+(idx*70+idx*10)+'px;'" -->
              <span v-if="item.isGift"
              style="left:0px"
                class="zen">赠品
              </span>
            <!-- </template> -->
          </div>
        </div>
        <div class="order_info_right">
          <p class="red">{{item.afterSaleInfo}}</p>
          <p class="attr"><span class="abnor_info" v-if="item.orderStatus == 'WAIT_SEND' &&item.urgeOrder && item.urgeOrder.urgeId">客户催发货x{{item.urgeOrder.urgeCount}}</span></p>
          <p class="red" v-show="item.printType">{{printTypeFormat[item.printType]}}</p>
          <p class="red" v-show="isPower['CASHIER_SYSTEM_INPUT'] && item.orderStatus == 'WAIT_SEND' && familiesPassStatus == '1' && item.familiesPassStatusCN">{{item.familiesPassStatusCN}}</p>
        </div>
      </div>
      <div class="order_btn">
        <div class="order_btn_left">
          <span v-if="item.appOrderItemVoList && item.appOrderItemVoList[0] && item.appOrderItemVoList[0].isVirtual == 'y'" :class="['active_type_vertiu']">虚拟商品</span>
          <span v-else :class="['active_type_'+item.orderType]">{{ordreTypeFormat[item.orderType]}}</span>
        </div>
        <div class="order_btn_right">
          <span class="adjustment" v-if="item.adjustStatus && item.adjustStatus  == 1">调</span>
          <span class="color33">共  <span class="order_red"> {{item.count}}</span> 件商品，合计</span>
          <span v-if="item.buyType == 2" class="order_red">{{item.totalExchangePoint}}积分</span>
          <span v-else-if="item.buyType == 3" class="order_red" style="font-family: DINAlternate-Bold, DINAlternate;">
            {{item.totalExchangePoint}}积分 + {{item.totalPrice}} 元
          </span>
          <span v-else class="order_red" v-price="item.sumPrice"></span>
        </div>
      </div>
      <!-- && item.mergeSendCode != item.subOrderList[0].mergeSendCode -->
      <div
        class="order_address address_top"
        :class="{'address_bottom': !item.expressType && !item.wayBillCode}"
        v-if="item.receiverAddress && item.appOrderItemVoList && item.appOrderItemVoList[0] && item.appOrderItemVoList[0].isVirtual != 'y' "
      >
        <div class="order_address_wrap">
          <div class="address_icon"  v-if="item.dispatchType != 5">
            <van-icon name="location-o" size="16px" style="vertical-align: top;" />
          </div>
          <div class="address_info">
            <p class="address_phone" v-if="item.dispatchType != 5">{{item.receiverName}}&nbsp;{{item.receiverPhone}}</p>
            <div :class="[{flex_address_text :item.dispatchType == 5},'address_text'] ">
              <div v-if="item.dispatchType == 5" class="mention">门店自提</div>
              <div @click="lookSendFun(item.id)">
                <span class="dji">订单轨迹</span>
                <van-icon
                  style="vertical-align: text-bottom;"
                  class="icon"
                  name="arrow"
                  size="16px"
                  color="#F8A651"
                />
              </div>
            </div>
            <p class="address_desc" v-if="item.dispatchType != 5">{{item.receiverAddress}}</p>
            <p class="address_biao">
              <span class="dfix" v-if="item.addressModifyStatus">{{setStatusFun(item.addressModifyStatus)}}</span>
              <span class="dtip" v-if="item.isFreeShippingCn">到付</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 部分发货订单 -->
      <div
        class="order_address address_top"
        v-if="item.orderStatus == 'PART_SEND'"
      >
        <div class="order_address_wrap">
          <div class="address_icon" >
            <van-icon name="location-o" size="16px" style="vertical-align: top;" />
          </div>
          <div class="address_info">
            <p class="address_phone">订单被分为多个包裹发出</p>
            <div class="address_text">
              <div @click="gotoExpress(item)">
                <span class="dji">  查看物流</span>
                <van-icon
                  style="vertical-align: text-bottom;"
                  class="icon"
                  name="arrow"
                  size="16px"
                  color="#F8A651"
                />
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- <div
        class="order_address address_top address_bottom"
        v-if="item.shadowBranchName"
      >
        <div class="order_address_wrap">
         影子店铺：{{item.shadowBranchName}}
        </div>
      </div> -->
      <div class="order_remark" v-if="item.branchRemark || item.branchRemarkTypeCN">
        <div class="order_address_wrap">
          <div class="address_icon">
            <span>备注:</span>
            <span :class="['dtip', 'cor' + item.branchRemarkType]" v-show="item.branchRemarkTypeCN">{{item.branchRemarkTypeCN}}</span>	  
          </div>
          <div class="text" @click="lookSendFun(item.id)">
            <p class="van-multi-ellipsis--l2">{{item.branchRemark}}</p>
            <p class="p2">最近编辑:{{item.branchRemarkTime}}  {{item.branchRemarkUser}}</p>
          </div>
          <div @click="lookSendFun(item.id)">
            <van-icon
              style="vertical-align: bottom;"
              class="icon"
              name="arrow"
              size="16px"
              color="#999999"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!isWebIM && item.expressType && item.wayBillCode && item.dispatchType != 5"
        class="order_address address_bottom address_heg"
      >
        <div class="order_address_wrap">
          <div class="address_icon">
            <img src="@/assets/image/scar@2x.png" class="img1" />
          </div>
          <div class="address_info">
            <p class="address_phone">物流公司：{{item.expressType}}</p>
            <div class="address_text">
              <div @click="lookPressFun(item)">
                <span class="dji">物流信息</span>
                <van-icon
                  style="vertical-align: text-bottom;"
                  class="icon"
                  name="arrow"
                  size="16px"
                  color="#F8A651"
                />
              </div>
            </div>
            <div class="other_address_desc">
              <p class="address_desc">快递单号：{{item.wayBillCode}}</p>
              <div class="repectInfo" @click="onRepectFile(item)">
                <span class="dji" style="font-size: 12px;">揽件回执</span>
                <van-icon
                  style="vertical-align: text-bottom;"
                  class="icon"
                  name="arrow"
                  size="16px"
                  color="#F8A651"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="item.dispatchType == 5 && item.orderStatus == 'WAIT_RECEIVING'" class="mention_module">
        <div class="keep">
          <div class="top">
            <div class="left">保留商品有效期</div>
            <div class="right1" v-if="validity">有效</div>
            <div class="right2" v-else>过期</div>
          </div>
          <div class="botton">{{ item.confirmTranTime }} - {{ this.endGoodTranTime }} </div>
        </div>
        <div class="pick_goods_code">
          <div class="top">提货码有效期</div>
          <div class="botton">{{ item.confirmTranTime }} - {{ item.ownTranCodeEndTime }} </div>
        </div>
      </div>
      <div class="liu0" v-if="item.remark">
        <div class="liu1">买家留言：</div>
        <div class="liu2">{{item.remark}}</div>
      </div>
    </van-panel>
    
    <!-- 赠品子订单，在视觉上是独立的子订单；但是返回数据的结构是在子订单里有个字段subOrderList记录着赠品订单 -->
    <template v-if="item.subOrderList && item.subOrderList.length>0">
      <div v-for="(row,index2) in item.subOrderList" :key="index2" :class="row.mergeSendCode ? '':'marbtn20'">
        <NormalZengItemVue
          :from="'normalorder'"
          :item.sync="row"
          :cIndex="cIndex"
          :isPower="isPower"
          :mergeSendCode="row.mergeSendCode && item.subOrderList && item.subOrderList[index2 + 1] &&   row.mergeSendCode  == item.subOrderList[index2 + 1].mergeSendCode"
          :yesPi="yesPi"
          :active="active"
          :familiesPassStatus="familiesPassStatus"
          @printCodeFunBySingel="printCodeFun"
          @callbackChoosezp="callbackChoosezp"
          @expressCode="expressCodezp"
        ></NormalZengItemVue>
      </div>
    </template>
    <CodePopBefore ref="CodePopBefore" @callbackFun="callbackParent"></CodePopBefore>
    <RemarkModel ref="RemarkModel" @callbackFun="callbackRemark"></RemarkModel>
    <PickModel ref="PickModel" @callbackFun="callbackParent"></PickModel>
    <van-dialog
      v-model="cancelShow"
      title="取消揽件"
      show-cancel-button
      confirmButtonText="确认取消揽件"
      cancelButtonText="我不取消了"
      confirmButtonColor= "#F8A651"
      @confirm="doCancel(item.id)"
      @cancel="cancelShow = false">
      <div class="canceldiv">
        <p class="p1">请确认是否已打印成功快递单，如果已打印快递单，请谨慎操作，避免线下已发货而取消揽件。</p>
        <p class="p2">温馨提示：</p>
        <p class="p2">打印快递码后，状态变为待收货会有一定延时,请耐心等待即可。</p>
      </div>
    </van-dialog>

    <!-- 自提确认弹窗 -->
    <van-dialog
      v-model="mentionShow"
      title="自提确认"
      show-cancel-button
      confirmButtonColor="#007AFF"
      cancelButtonColor="#666666"
      @confirm="confirmMention"
      :lockScroll="sliding"
    >
      <div class="mention_body">
        <div class="head">
          <p class="ask">确认有货，等待用户到店自提吗？</p>
          <p class="tip">确认后，用户才能进行自提，自提到店出示提货码，扫码核销即可完成提货</p>
        </div>
        <van-divider />
        <div class="tail">
          <p class="tip">自提说明：店铺确认自提后，必须保留商品一段时间，避免用户到店后无货产生争议，影响用户体验，到店产生纠纷。</p>
          <p class="content">保留期过后，自提商品支持继续核销在提货码有效期内。同时如线下用户购买可优先线下用户，当商品售尽不能自提时，请主动联系用户说明情况已经没货，申请退款。</p>
        </div>
      </div>
    </van-dialog>

    <codePop-by-machine ref="CodePopByMachine" @callback="codePopByMachineCallback"></codePop-by-machine>
    <deliverSelectGift ref="deliverSelectGift" @onNoMerge="onNoMerge" @mergeDeliver="mergeDeliver"></deliverSelectGift>
    <send-config-popup ref="sendConfigPopup" :orderItem="[{...item,appSubOrderItemDetailVoList:item.appOrderItemVoList}]" @reconfirm="reconfirmFn" :zengpin="sendGiftList.length>0?[{...sendGiftList[0],appSubOrderItemDetailVoList: sendGiftList[0].orderItemList}]:[]" :isMerge="isMerge"></send-config-popup>
  </div>
</template>
<script>
import http from "@/utils/axios";
import Util from "@/utils/common";
import CodePopBefore from "@/views/beeorder/components/codePopBefore";
import RemarkModel from "@/views/beeorder/components/remarkModel";
import PickModel from "@/views/beeorder/components/pickModel";
import CodePopByMachine from "@/views/beeorder/components/codePopByMachine";
import NormalZengItemVue from "./normalZengItem.vue";
import deliverSelectGift from './deliverSelectGift'
import SendConfigPopup from './sendConfigPopup.vue';

export default {
  name: "allorderitem",
  data() {
    var isEnableTicket = localStorage.getItem('isEnableTicket') || '禁用'
    return {
      subOrderIdVO:{},
      giftSubOrderDetailVoList:{},
      btnType:1,// 1 普通商品提交并发货  2 快递码 3 快递码-- 赠品弹窗 --单独发货 4快递码-- 赠品弹窗 --合并发货
      isMerge:false,//是否合并发货 查看页
      reconfirmPopup:false,
      isWebIM: window.isWebIM,
      isEnableTicket:isEnableTicket,
      printTypeinfo:1,
      sliding: true,
      printType: "",
      repeaGetPowerLoading: false,
      printTypeFormat: {
        EXPRESSMAN_PRINT: "快递员打印",
        SELF_PRINT: "自行打印",
      },
      cancelShow: false,
      machineTwoLoading: false,
      machineThreeLoading: false,
      ordreTypeFormat:{
        'NORMAL_ORDER': '预置商品',
        'QUICK_ORDER': '快速商品'
      },
      mentionShow: false,
      subOrderId: '',  // 子订单主键id
      endTranTime: '',  // 提货码有效期结束日期
      endGoodTranTime: '',  // 保留商品有效期结束日期
      validity: false,
      sendGiftList:[],
      findHasNoSend:false,
      mergeSendCode:false,
      lianmurl:require('@/assets/order/lianmvip.png'),
    };
  },
  props: {
    //用于判断是哪个页面调用
    from: {
      type: String,
      default: ''
    },
    item: {
      default: function () {
        return {}
      },
      type: Object,
      required: true,
    },
    isPower: {
      default: () => {
        return {};
      },
      type: Object,
      required: true,
    },
    yesPi: {
      default: false,
      type: Boolean,
    },
    cIndex: {
      default: 0,
      type: Number,
    },
    familiesPassStatus: {
      default: '',
      type: [Number, String],
    },
    active: {
      default: '',
      type: [Number, String]
    },
    subOrderList:{
      default: () => [],
      type:Array
    }
  },
  watch:{
    subOrderList:{
      deep: true,
      immediate: true, // 马上监听触发
      handler (newVal, oldVal) {
        let mergeSendCode = this.item.mergeSendCode || '';
        let subOrderList = newVal || [];
        this.mergeSendCode =  subOrderList.some(item=>{
          if(item.mergeSendCode){
            return item.mergeSendCode == mergeSendCode
          }
         
        })            
      }
    }
  },
  created() {
    if (this.item.confirmTranTime) {
      // 计算有效期结束时间
      let strTime = new Date(this.item.confirmTranTime.replace(/-/g, '/'))

      let endTime = strTime.getTime()
      endTime += 30 * (24 * 3600 * 1000)
      let endTranTime = new Date(endTime)
      this.endTranTime = this.DateToStr(endTranTime)
      // 计算保留商品有效期
      let endGoodTime = strTime.getTime()
      endGoodTime += this.item.ownDay * (24 * 3600 * 1000)
      let endGoodTranTime = new Date(endGoodTime)
      this.endGoodTranTime = this.DateToStr(endGoodTranTime)

      // 判断自提码是否过期
      let today = new Date().getTime()
      this.validity = today > endGoodTime ? false : true
    }

  },
  methods: {
    reconfirmFn() { // 发货二次确认弹窗 点了确认无误
      this.reconfirmPopup = true;
      if (this.btnType == 1) {
        this.expressCodeCheck();
      }else if (this.btnType == 2) { // 快递码
        this.$refs["CodePopBefore"] && this.$refs["CodePopBefore"].getPowerFun(this.item, this.printType, this.isPrintAll);
      }else if (this.btnType == 3 ) { //快递码 赠品弹窗 单独发货
        this.$refs['CodePopBefore'] && this.$refs['CodePopBefore'].getPowerFun(this.item, this.printType,this.isPrintAll)
      }else if (this.btnType == 4) { // 快递码 赠品弹窗 合并发货
        this.$refs['CodePopBefore'] && this.$refs['CodePopBefore'].getPowerFun(this.item, this.printType,this.isPrintAll,{},this.subOrderIdVO);
      }
    },
    gotoExpress(item){
      console.log(item);
      // subid
      this.$router.push({
        name: "userExpress",
        query: {
          subid: item.id,
        }
      });

    },
    print_ticket(item){ // 打印小票
      console.log(item);
      if (this.printTypeinfo == 3||this.printTypeinfo==2 || item.ticketId) { 
        return
      }
      this.printTypeinfo = 2;
      http({
        url: "order/appOrder/bees/printSaleTicket/"+this.item.id,
        method: "post"
      }).then(res => {

        if (res.code==200) {
          console.log(res,111);
          this.$toast(res.message);
          this.printTypeinfo = 3
        }else {
          console.log(res,222);
          this.printTypeinfo = 1
          this.$toast(res.message);

        }
        
      })
    },
    // 赠品列表 
    async  findHasNoSendGiftSubOrder(){
        await http({
        url: `order/appOrder/order/findHasNoSendGiftSubOrder/${this.item.id}`,
        method: "get"
      }).then(res => {
        if (res.code == 200 ) {
           this.sendGiftList = res.data;
           return res.data.length;

        }
      })
    },
     // 获取赠品子订单是否有未发货的商品单
     async findHasNoSendSubOrderByGiftOrder(){
      await http({
        url: `order/appOrder/order/findHasNoSendSubOrderByGiftOrder/${this.item.id}`,
        method: "get"
      }).then(res => {
        if (res.code == 200 ) {
           this.findHasNoSend = res.data;
           return res.data
        }
      })
    },
    printCodeFun(id,index,needReprint){
      this.$emit("printCodeFunBySingel", id, index, needReprint);
    },
    /**
     * 自提确认弹窗确认
     */
    confirmMention() {
      http({
        url: "order/admin/confirmTran/" + this.subOrderId,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.mentionShow = false
          this.$toast('操作成功')
          this.$emit('callbackRemark')
        }
      })
    },
    /**
     * 有货可提按钮
     */
    mentionClick(item) {
      this.mentionShow = true
      this.subOrderId = item.id
    },
    /**
     * 自提核销
     */
    mentionVerification() {
      let obj = {tm: 3070100, tp: {}}
      Util.nativeMethod(obj)
    },
    /**
     * 判断该订单是否为库存100订单 && 是否发生过退单
     */
    isInventory100(supplierChannel, chargebackType) { 
      if (chargebackType == 1 && supplierChannel == 1) {
        return false
      } else {
        return true
      }
    },
    /**
     * 控制 线下入机 按钮的显示与隐藏
     */
    funIsShowKCOne(item){
        if (item.actualAfter) {
          return false;
        }else{
          if(this.isPower['CASHIER_SYSTEM_INPUT'] && this.familiesPassStatus == '1' && item.orderStatus == 'WAIT_SEND'){
            return this.isInventory100(item.supplierChannel, item.chargebackType)
          }else{
            return false
          }
        }
    },
    /**
     * 控制 二维码入机 按钮的显示与隐藏
     */
    funIsShowKCTwo(item){
      if (item.actualAfter) {
        return false;
      }else{
        if(this.isPower['CASHIER_SYSTEM_INPUT'] && this.familiesPassStatus == '1' && item.orderStatus == 'WAIT_SEND'){
          return this.isInventory100(item.supplierChannel, item.chargebackType)
        }else{
          return false
        }
      }
    },
    funIsShowKCThree(item){
      if (item.actualAfter) {
        return false;
      }else{
        if(this.isPower['CASHIER_SYSTEM_INPUT'] && this.familiesPassStatus == '2' && item.orderStatus == 'WAIT_SEND' && item.supplierChannel != 1){
          return true
        }else{
          return false
        }
      }
    },
    /**
     * 控制 发货 按钮的显示与隐藏
     */
    funIsShow(item) {
      // 蜜蜂go开放对库存100订单操作的权限 
      if (item.actualAfter) {
        return false;
      }else{
        if (['PART_SEND','WAIT_SEND'].includes(item.orderStatus) && this.familiesPassStatus != '1' && item.deliveryPermit) {
          return this.isInventory100(item.supplierChannel, item.chargebackType)
        }else{
          return false
        }
      }
    },
    funIsShowCancel(item) {
      if(this.isPower["EXPRESSMAN_PRINT"]){
        if (
          item.orderStatus == "PRINTED" ||
          item.orderStatus == "WAIT_PRINT" ||
          item.orderStatus == "PRINT_FAIL"
        ) {
          return true;
        } else {
          return false;
        }
      }else{
        return false;
      }
    },
    funIsShowExpress(item) {
      if (item.actualAfter || item.isFreeShippingCn) {
        return false;
      } else {
        if (this.isPower["EXPRESSMAN_PRINT"] && this.familiesPassStatus != '1' && (item.orderStatus == "PRINT_FAIL" || item.orderStatus == "WAIT_PRINT")) {
          return true;
        } else {
          return false;
        }
      }
    },
    /**
     * 控制 快递码 按钮的显示与隐藏
     */
    funIsShowExpressSend(item){
      if(item.actualAfter || item.isFreeShippingCn) {
        return false
      }else{
        if(this.isPower['EXPRESSMAN_PRINT'] && ['PART_SEND','WAIT_SEND'].includes(item.orderStatus) && this.familiesPassStatus != '1' && item.deliveryPermit ){
          return this.isInventory100(item.supplierChannel, item.chargebackType)
        }else{
          return false
        }
      }
    },
    funIsShowPicking(item) {
      if (item.actualAfter || item.isFreeShippingCn) {
        return false;
      } else {
        if(this.isPower["PRINT_PICKING_LIST"] && this.familiesPassStatus != '1' && (item.orderStatus == "PRINT_FAIL" || item.orderStatus == "WAIT_PRINT") ) {
          return true;
        } else {
          return false;
        }
      }
    },
    funIsShowPickingSend(item) {
      if (item.actualAfter || item.isFreeShippingCn) {
        return false;
      } else {
        if (this.isPower['PRINT_PICKING_LIST'] && ['PART_SEND','WAIT_SEND'].includes(item.orderStatus) && this.familiesPassStatus != '1') {
          return true;
        } else {
          return false;
        }
      }
    },
    funIsShowExpressCode(item){
      if (item.actualAfter || item.isFreeShippingCn) {
        return false;
      } else {
        if (this.isPower["EXPRESS_PUSH"] && this.familiesPassStatus != '1' && (item.orderStatus == "PRINT_FAIL" || item.orderStatus == "WAIT_PRINT")) {
          return true;
        } else {
          return false;
        }
      }
    },
    sendExpressCode(item) {
      this.$emit('expressCode', item)
    },
    onRepectFile(item) {
      this.$emit('repectFile', item)
    },
    funIsShowPickingThree(item){
      if (item.actualAfter || item.isFreeShippingCn) {
        return false;
      }else{
        //dispatchType 发货类型  1 手工发货  2 快递码发货 3 自行打印发货 5 门店自提
        if (this.isPower['EXPRESSMAN_PRINT'] && item.orderStatus == 'WAIT_RECEIVING' && item.dispatchType && item.dispatchType != 1 && this.familiesPassStatus != '1') {
          return true;
        } else {
          return false;
        }
      }
    },
    /**
     * 控制 自行打印 按钮的显示与隐藏
     */
    funIsShowSelfPrintSend(item) {
      if (item.actualAfter || item.isFreeShippingCn) {
        return false;
      } else {
        if (item.isAdjustProcessing) {
          return false
        }
        if (this.isPower['SELF_PRINT'] && ['PART_SEND','WAIT_SEND'].includes(item.orderStatus) && this.familiesPassStatus != '1') {
          return this.isInventory100(item.supplierChannel, item.chargebackType)
        } else {
          return false;
        }
      }
    },
    funIsShowafter(item) {
      if (item.afterSaleId && item.afterSaleInfo == "售后中") {
        return true;
      }
    },
    funStatus(status) {
      let text = "";
      switch (status) {
        case "WAIT_PAY":
          text = "待付款";
          break;
        case "IN_STOCK":
          text = "备货中";
          break;
        case "WAIT_SEND":
          text = "待发货";
          break;
        case "WAIT_RECEIVING":
          text = "待收货";
          break;
        case "COMPLETED":
          text = "已完成";
          break;
        case "CANCEL_TIMEOUT":
          text = "超时关闭";
          break;
        case "WAIT_PRINT":
          text = "待打印";
          break;
        case "PRINTED":
          text = "待揽件";
          break;
        case "PRINT_FAIL":
          text = "打印失败";
          break;
        case "WAIT_PLATFORM_AUDIT":
          text ="待平台审核";
          break;
        case "GROUP_WAIT_SHARE":
          text ="待分享";
          break;
        case "GROUP_FAIL":
          text ="拼团失败";
          break;      
        case "GROUP_FAIL":
          text ="拼团失败";
          break;  
        case "PART_SEND":
          text ="部分发货";
          break;  
        default:
          text = "已取消";
          break;
      }
      return text;
    },
    contactFun(bid, branchId) {
      http({
        url: "order/netease/chat/branch/config",
        method: "post",
        parmes: {
          branchId,
          userId: bid,
        },
      }).then(res => {
        if (res.code == 200) {
          if (window.isBeeMiniApp) {
            // 跳转小程序中转页
            var idStr = ''
            if (res.data && res.data.teamChatId) {
              idStr = `teamChatId=${res.data.teamChatId}`
            } else {
              idStr = `contactId=${bid}`
            }
            wx.miniProgram.navigateTo({
              url: `/pages/index/index?type=contact&${idStr}`
            });

          } else {
            if (res.data && res.data.teamChatId) {
              Util.userChat(bid, res.data.teamChatId);
            } else {
              Util.userChat(bid, undefined);
            }
          }
        }
      })
    },
    funSubstring(name) {
      if (name && name.length > 20) {
        return `${name.substring(20, 0)}...`;
      } else {
        return name;
      }
    },
    // showsend  默认字符 说明点击非按钮位置进入
    goDetaiFun(row,showsend) {
      // PART_SEND  部分发货订单
      if(row.isShowSend && showsend === undefined && row.orderStatus == 'PART_SEND'){
         return this.$toast("该订单需在ERP系统发货！");
      }
      const env = this.$route.query.env;
      let url = `${window.location.origin}/h5user/beesOrderDetail?env=${env}role=bees&dispatchType=${row.dispatchType}&subId=${row.id}&cindex=${this.cIndex}&pcode=${this.familiesPassStatus}`
      Util.jumpToNewPage({
        noTitle: "0",
        url:url
      });
    },
    toAfterInfo() {
      this.$router.push({
        name: "personnelafterorder",
        query: {
          afterId: this.item.afterSaleId,
        },
      });
    },

    onNoMerge(){
      this.btnType = 3 
      this.isMerge = false;
      this.$refs.sendConfigPopup.poupShow();
      // this.$refs['CodePopBefore'] && this.$refs['CodePopBefore'].getPowerFun(this.item, this.printType,this.isPrintAll)
         // 原来的流程
    },
    //  合并 (快递码) 合并生成 把选中的子订单传入 codePopBefore 这个组件中
    mergeDeliver(subOrderIdVO){
      this.btnType = 4
      this.isMerge = true;
      this.subOrderIdVO = subOrderIdVO;
      this.$refs.sendConfigPopup.poupShow();
      // this.$refs['CodePopBefore'] && this.$refs['CodePopBefore'].getPowerFun(this.item, this.printType,this.isPrintAll,{},subOrderIdVO);
    },

    async openFun(item, printType, isPrintAll='') {
      this.printType = printType;
      this.isPrintAll = isPrintAll;
      // 快递码  自行打印  
      // PART_SEND  部分发货订单
      if((item.orderStatus == 'PART_SEND' && printType != 2) || (item.isShowSend && (printType == 0 ||  printType == 1))){
          return this.$toast("该订单需在ERP系统发货！");
      }
      console.log('item',item.isGift)
      if(item.isGift){
        // 赠品
        await this.findHasNoSendSubOrderByGiftOrder();
      }else{
        await this.findHasNoSendGiftSubOrder();
      }
        // 增加赠品弹窗
      if(printType == 0 || printType == 1){
        this.btnType = 2
        console.log('item.isGift',item.isGift,this.findHasNoSend)
        //  是赠品判断
        if(item.isGift){
          if(this.findHasNoSend){
            this.$dialog.confirm({
              title: "温馨提示",
              message: "本订单是赠品订单，关联的子订单未发货，可在商品订单进行合并发货操作，是否继续操作？",
              confirmButtonColor: "#F8A651",
            })
            .then(() => {
              this.$refs.sendConfigPopup.poupShow();
              // this.$refs["CodePopBefore"] && this.$refs["CodePopBefore"].getPowerFun(item, printType, isPrintAll);
            })
          }else{
            this.$refs.sendConfigPopup.poupShow();
            // this.$refs["CodePopBefore"] && this.$refs["CodePopBefore"].getPowerFun(item, printType, isPrintAll);
          }
        }else{
            //是商品 在判断是否有赠品的选择
          if(this.sendGiftList.length > 0){
            this.$refs['deliverSelectGift'] && this.$refs['deliverSelectGift'].popupShow('code',this.sendGiftList,this.item.id);
          }else{
            this.$refs.sendConfigPopup.poupShow();
            // this.$refs["CodePopBefore"] && this.$refs["CodePopBefore"].getPowerFun(item, printType, isPrintAll);
          }
        }
      }else{
        this.$refs.sendConfigPopup.poupShow();
        // this.$refs["CodePopBefore"] && this.$refs["CodePopBefore"].getPowerFun(item, printType, isPrintAll);
        if(item.orderStatus == 'PART_SEND' && printType == 2) return
        this.$refs["CodePopBefore"] && this.$refs["CodePopBefore"].getPowerFun(item, printType, isPrintAll);
      }
    },
    callbackParent(currSubOrderId) {
      this.$emit("callbackFun", currSubOrderId);
    },
    doCancel(subOrderId) {
      http({
        url: "order/admin/cancelSystemDelivery/" + subOrderId,
        method: "POST",
        parmes: {},
      })
        .then((rps) => {
          if (rps.code === 200 && rps.data) {
            this.$toast(rps.message || "取消打印成功");
            this.$emit("callbackFunByCancel", subOrderId);
          }
        })
        .catch((rps) => {});
    },
    //订单轨迹
    lookSendFun(subOrderId) {
      let url = `${window.location.origin}/h5user/forllowSub?subid=${subOrderId}`;
      Util.jumpToNewPage({
        url: url,
        noTitle: "0",
      });
    },
    repeaGetPowerFun(id) {
      this.repeaGetPowerLoading = true;
      http({
        url: "order/admin/reprintDeliverBill/" + id,
        method: "POST",
      })
        .then((rps) => {
          if (rps.code === 200) {
            if (!rps.data.result) {
              this.$dialog
                .alert({
                  title: "提示",
                  confirmButtonColor: "#F8A651",
                  confirmButtonText: "知道了",
                  message: rps.data.message || "",
                })
                .then(() => {
                  this.repeaGetPowerLoading = false;
                });
            }
            if (rps.data.result) {
              this.$toast(rps.message || "成功");
              this.$emit("callbackFun", id);
              this.repeaGetPowerLoading = false;
            }
          }
        })
        .catch((rps) => {
          this.repeaGetPowerLoading = false;
        });
    },
    expressCodezp(row){
      this.$emit("expressCode", row,);
    },
    callbackChoosezp(row){
      this.$emit("callbackChoose", row,);
    },
    checkboxFun(row, ) {
      console.log(row)
      this.item.checked= !this.item.checked
      this.$emit("callbackChoose", row);
    }, 
    /**
     * 生成二维码到相册
     */
    getTwoCodeFun(item, needReprint = 0) {
      if(item.isShowSend){
          return this.$toast("该订单需在ERP系统发货！");
      }
      this.$emit("printCodeFunBySingel", item.id, 1, needReprint);
    },
    setStatusFun(item) {
      switch (item) {
        case 1:
          return "待客户修改";
          break;
        case 2:
          return "已修改完成";
          break;
        case 3:
          return "修改超时";
          break;
        case 4:
          return "撤销修改";
          break;
        default:
          break;
      }
    },
    openRemarkVisibleFun(row){
      this.$refs['RemarkModel'] && this.$refs['RemarkModel'].init(row, this.from)
    },
    callbackRemark(){
      this.$emit('callbackRemark')
    },
    lookPressFun(item){
      let options={}
      this.$store.dispatch('setExpressObjData',{
        payTime: item.createTime,
        subOrderCode: item.subOrderCode,
        imgUrl:  (item.appOrderItemVoList || []).length ? item.appOrderItemVoList[0].skuImageKey : ''
      })
      if(this.from === 'normalorder'){
        options = {
          role: 'bees',
          dispatchType:item.dispatchType,
          subid: item.id
        }
      }else{
        options = {
          subid: item.id
        }
      }
      this.$router.push({name: "userExpress",query: options});
    },
    checkPickingOnceFun(item){
      this.$dialog.confirm({
        title: '打印拣货单',
        message: '确认打印该订单拣货单？',
        confirmButtonColor: '#F8A651'
      }).then(()=>{
        let parm = {
          "isPrintAll": 0,
          "subOrderIdList": [item.id]
        }
        this.$refs["PickModel"] &&
        this.$refs["PickModel"].doPickingFun(parm);
      }).catch(()=>{})
    },
    checkPickingTiwceFun(item){
      this.$dialog.confirm({
        title: '打印快递面单',
        message: '如快递面单已损毁或丢失，可扫码重新打印快递面单',
        confirmButtonColor: '#F8A651'
      }).then(()=>{
        let parm = {
          "isPrintAll": '0',
          "subOrderIdList": [item.id]
        }
        this.$refs["PickModel"] &&
        this.$refs["PickModel"].doPickingFun(parm);
      }).catch(()=>{})
    },
    handlerMachineTwo(item){
      this.machineTwoLoading = true
      if(this.$refs['CodePopByMachine']){
        this.$refs['CodePopByMachine'].subId = item.id
        this.$refs['CodePopByMachine'].init()
      }
    },
    codePopByMachineCallback(){
      this.machineTwoLoading = false
      this.$refs['CodePopByMachine'] && (this.$refs['CodePopByMachine'].visible = false)
      this.$emit('callbackRemark')
    },
    handlerMaineOne(item){
      this.$router.push({name: 'beeInMachine', query:{subId: item.id}})
    },
    handlerMaineThree(item){
      this.machineThreeLoading = true
      http({
        url: "order/admin/receipt/reprint",
        method: "POST",
        parmes: {
          "subOrderId": item.id
        },
      })
        .then((rps) => {
          if (rps.code === 200 && rps.data) {
            this.$toast(rps.message || "成功");
            this.machineThreeLoading = false
          }
        })
        .catch((rps) => {});
    },
    //重新快递单 满足item.dispatchType==3(已自行打印) && orderStatus='WAIT_RECEIVING'(待收货)
    reprintExpressBill(subOrderId) {
      const dangerMessage = '<p style="color: red; margin-top: 0.133rem">请仔细核对是否已经发货，避免重打多次发货</p>'
      this.$dialog.confirm({
        title: '打印快递面单',
        message: '如快递面单已损毁或丢失，可扫码重新打印快递面单' + dangerMessage,
        confirmButtonColor: '#F8A651'
      }).then(()=>{
        http({
          url: "order/admin/reprintDeliverBill/" + subOrderId,
          method: "POST"
        }).then(rps => {
          if(rps.code == 200) {
            this.$toast('操作成功')
          }
        })
      }).catch(()=>{})
    },
    //item.isAllowConfirmDelivery 待揽件-待打印 && orderStatus='PRINT_FAIL' && 有物流信息 才会出现确认发货按钮
    onConfirmShipment(subOrderId) {
      const message = 
        '<div style="text-align: left">' +
          '使用快递码打印，如成功打印面单和发货，请手动确认发货，确认后订单状态由待揽件变为待收货。' +
          '<p style="color: red; margin-top: 0.233rem">' +
            '打印失败说明：\n因硬件或网络等问题可能导致线下已真实打印，但结果为失败，需要手动确认商家已发货' +
          '</p>' +
        '</div>'         
      this.$dialog.confirm({
        title: '确认发货',
        message,
        confirmButtonText: '确认发货',
        confirmButtonColor: '#F8A651'
      }).then(()=>{
        http({
          url: "order/express/confirmDelivery/" + subOrderId,
          method: "POST"
        }).then(rps => {
          if(rps.code == 200) {
            this.$toast('操作成功')
            this.$emit('callbackRemark')
          }
        })
      }).catch(()=>{})
    },
    /**
     * 日期转字符串格式
     */
    DateToStr(date) {
     let year = date.getFullYear()
     let month = date.getMonth()
     let day = date.getDate()
     let hours = date.getHours()
     let min = date.getMinutes()
     let second = date.getSeconds()
     return year + "/" +
      ((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "/" +
      (day > 9 ? day : ("0" + day)) + " " +
      (hours > 9 ? hours : ("0" + hours)) + ":" +
      (min > 9 ? min : ("0" + min)) + ":" +
      (second > 9 ? second : ("0" + second))
    }
  },
  components: { CodePopBefore,RemarkModel,PickModel,CodePopByMachine,NormalZengItemVue,deliverSelectGift,SendConfigPopup },
};
</script>
<style lang="less" scoped>
.marbtn20{
  margin-bottom: 20px;
}
.Symbol{
  color: #333333;
  font: size 24px; ;
}
.goodsPrice{
  color: #333333;
  font-size: 32px;
  font-weight:600 ;
}
.goodsPoint{
  font-size: 24px;
  color: #333333;
  font-weight: bold;
  span{
    font-family: DINAlternate-Bold, DINAlternate;
  }
}
.member_price_identification {
  position: relative;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 20px;
  border-radius: 8px 4px 0 8px;
  padding: 2px 8px 0 8px;
  box-sizing: border-box;
  .triangle {
    position: absolute;
    right: 0;
    bottom: -12px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
  }
}
.order_red{
  color: #ED3939;
  font-weight: 600;
  display: inline-block;
}
/deep/ .van-badge{
  width: 46px;
  height: 36px;
  border-radius:10px;
  line-height: 36px;
  margin-right: 4px;
  margin-right: 14px;
  display: block;
}


.mention_body {
  margin-top: 20px;
  padding: 0 50px;
  .head {
    .ask {
      font-size: 28px;
      color: #666666;
      text-align: center;
    }
    .tip {
      font-size: 24px;
      font-weight: 500;
      color: #529CF9;
      text-align: center;
      margin-top: 32px;
    }
  }
  .tail {
    padding: 0 18px;
    font-size: 20px;
    .tip {
      font-weight: 500;
      color: #ED3939;
      margin-bottom: 20px;
    }
    .content {
      color: #999999;
      margin-bottom: 32px;
    }
  }
}

.adjustment{
  display: inline-block;
  text-align: center;
  width: 36px;
  height: 36px;
  background: #FFE8E8;
  border-radius: 10px;
  border: 1px solid #ED3939;
  margin-right: 10rpx;
  font-size: 20px;
  color: #ED3939;
  margin-right: 10px;
}
.abnor_info{
  background: #ED3939;
  border-radius: 10px;
  color: #fff;
  padding: 5px;
  box-sizing: border-box;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 1000;
}
.all_order_item {
  // margin-bottom: 20px;
  .van-cell-group {
    border-radius: 10px;
    padding-bottom: 20px;
  }
  .panel {
    padding: 20px 30px;
    .index-order-stock {
      font-size: 22px;
      color: #F8A651;
      font-weight: 500;
      margin-left: 40px;
    }
  }
  .panel_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    /deep/.van-checkbox__icon--checked .van-icon{
      color: #333;
      background-color: #fff;
      border-color:#c8c9cc ;
    }
    .panel_header_time{
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    .panel_header_title {
      font-size: 24px;
      color: #333333;
      display: flex;
      flex: 1;
      margin-left: 15px;
      align-items: center;
      font-weight: 500;
      .van-icon {
        padding-right: 10px;
        color: #999;
      }
    }
    .panel_header_value {
      color: #f8a651;
      font-size: 24px;
      font-weight: bold;
    }
    .panel_header_desc {
      color: #ccc;
      font-size: 24px;
      margin-right: 10px;
    }
  }
  .order_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
    position: relative;
    .order_info {
      display: flex;
      width: 100%;
      .info {
        flex: 1;
        width: 75%;
        .infop1 {
          display: flex;
          justify-content: space-between;
          font-size: 26px;
          p {
            color: #999;
           
          }
          strong {
            // width: 95%;
            word-break: break-all;
            color: #333;
            	white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .right_price {
            // width: 130px;
            // min-width: 90px;
            display: flex;
            justify-content: space-between;
            p {
              display: block;
              // text-align: right;
              // white-space: nowrap;
            }
          }
        }
        .attr_padd{
            padding-top: 10px!important;
        }
        .attr {
          color: #999999;
          font-size: 24px;
          padding-top: 5px;
          clear: both;
          .goods-code {
            color: #cccccc;
            font-size: 24px;
            line-height: 33px;
            word-break: break-all;
          }
          .abnor_info{
            background: #ED3939;
            border-radius: 10px;
            color: #fff;
            padding: 5px;
            box-sizing: border-box;
          }
          .ke{
            color: #ED3939;
            font-size: 20px;
            float: right;
          }
        }
      }

      .img {
        width: 160px;
        height: 160px;
        margin-right: 20px;
        overflow: hidden;
        border-radius: 10px;
        position: relative;
          .zen{
            width: 64px;
            height: 32px;
            background: #E15554;
            border-radius: 4px;
            font-size: 24px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            line-height: 32px;
            position: absolute;
            top: 0px;
          }
        .group-buying-people-label {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          height: 26px;
          font-size: 18px;
          padding: 0 8px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          line-height: 1;
        } 
      }
    }
    .order_info_left {
      flex: 1;
      white-space: nowrap;
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      .order_info_img {
        white-space: nowrap;
        flex-wrap: nowrap;
        overflow-x: scroll;
        overflow-y: hidden;
        .van-image {
          margin: 0 10px;
        }
      }
    }
    .order_info_right {
      min-width: 120px;
    }
  }
  .order_btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .color99 {
      color: #999;
    }
    .color33{
      color: #333;
      margin-right: 10px;
    }
    .order_btn_left {
      span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 160px;
        height: 36px;
        // line-height: 1px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        border-radius: 10px;
        // padding: 4px 30px;
      }
      .active_type_NORMAL_ORDER{
        background-color: #F8A651;
      }
      .active_type_QUICK_ORDER{
        background-color: #ED3939;
      }
      .active_type_vertiu{
        background-color: #FD9090;
      }
    }
  }
  /deep/.van-panel__footer:not(:first-child) {
    padding: 0;
  }
  .footer {
    text-align: right;
    padding-right: 30px;
    // display: flex;
    // justify-content: end;
    // align-items: center;
    // flex-wrap: wrap;
    button {
      margin-left: 17px;
      margin-bottom: 10px;
    }
    .div-btn-a {
      border-radius: 32px;
      font-size: 24px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .w1{
      width: 165px;
      margin-bottom: 10px;
    }
    .w2{
      //  width: 165px;
    }
    /deep/ .w3 {
      border-color:#999 !important;
    }
    .color33 {
      color: var(--epTextColor);
      /deep/.van-button__text {
        color: var(--epTextColor);
      }
    }
    .color99 {
      color: #999;
      /deep/.van-button__text {
        color: #999;
      }
    }
  }
  .footer-wrap__kc100 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .kc_text {
      display: flex;
      align-items: center;
      .footer-wrap__kc100--picture {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      .footer-wrap__kc100--name{
        font-size: 22px;
        color: #999;
      }
    }
    .div-btn-a {
      border-radius: 10px;
      color: #999;
      font-size: 22px;
      margin-left: 5px;
    }
    .w1 {
      width: 165px;
      
    }
  }
  .webim-footer {
    line-height: normal;
    font-size: 24px;
    text-align: right;
    padding: 0 24px;
    .van-button {
      min-width: 165px;
      border-color: #999;
    }
  }
  .order_address {
    display: flex;
    margin: 16px 30px;
    background: #f7f7f7;
    min-height: 139px;
    padding: 0 20px;
    align-items: center;
    .order_address_wrap {
      display: flex;
      justify-content: flex-start;
      padding: 10px 0;
      width: 100%;
      .address_info {
        // padding-left: 10px;
        position: relative;
        flex: 1;
        .address_phone {
          color: #666;
          font-weight: 500;
          font-size: 24px;
          padding-bottom: 5px;
          max-width: 400px;
          .address_status {
            font-size: 20px;
            color: #ed3939;
          }
        }
        .other_address_desc{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .repectInfo{
            display: flex;
            align-items: center;
            // padding-right: 30px;
            span{
              color: #f8a651;
            }
          }
        }
        .address_desc {
          color: #999;
          font-size: 20px;
        }
        .flex_address_text{
          width: 100%;
          justify-content: space-between;
        }
        .address_text {
          color: #f8a651;
          font-size: 24px;
          // height: 40px;
          // line-height: 40px;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
          // margin-right: 30px;
          display: flex;
          align-items: center;
          .dji {
            margin-left: 10px;
            height: 20px;
            line-height: 20px;
            display: inline-block;
          }
          .mention {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 112px;
            height: 32px;
            text-align: center;
            font-size: 20px;
            font-weight: 500;
            color: #333333;
            background-image: url(../../../assets/image/mention.png);
            background-repeat: no-repeat;
            background-size: cover;
            -webkit-background-size: cover;
            -o-background-size: cover;
            background-position: center 0;
            margin-right: 10px;
          }
        }
        .address_biao {
          text-align: right;
          margin-right: 30px;
          .dfix {
            font-size: 20px;
            color: #ed3939;
            margin-left: 10px;
          }
          .dtip {
            text-align: center;
            padding: 1px 5px;
            border-radius: 6px;
            border: 1PX solid #ed3939;
            color: #ed3939;
            font-size: 20px;
            margin-left: 10px;
          }
        }
      }
      .address_icon {
        //padding-right: 10px;
        // padding-left: 20px;
        width: 7%;
        .van-icon {
          color: #999;
        }
        .img1 {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .order_remark{
    display: flex;
    margin: 0 30px;
    background: #ffffff;
    height: 139px;
    padding: 0 20px;
    align-items: center;
    .order_address_wrap {
      display: flex;
      padding: 10px 0;
      width: 100%;
      .address_icon {
        color: #999;
        min-width: 180px;
        font-size: 24px;
        .dtip {
          text-align: center;
          padding: 1px 5px;
          border-radius: 6px;
          font-size: 20px;
          margin-left: 10px;
        }
        .cor1{
          border: 1PX solid #ed3939;
          color: #ed3939;
        }
        .cor2{
          border: 1PX solid #F8A651;
          color: #F8A651;
        }
        .cor3{
          border: 1PX solid #409EFF;
          color: #409EFF;
        }
      }
      .text{
        font-size: 20px;
        color: #999999;
        word-break:break-all;
        word-break:normal 
        .p2{
          color: #cccccc;
        }
      }
    }
  }
  .mention_module {
    height: 152px;
    background: #F7F7F7;
    border-radius: 10px;
    padding: 20px 30px;
    margin: 0 30px;
    .keep {
      font-size: 20px;
      color: #999999;
      .top {
        display: flex;
        align-items: center;
        .left {
          font-size: 24px;
          color: #666;
          margin-right: 10px;
        }
        .right1 {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 72px;
          height: 32px;
          background-image: url('../../../assets/image/effective.png');
          background-size:100% 100%;
          text-align: center;
          font-weight: 500;
          color: #333;
          font-size: 20px;
        }
        .right2 {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 72px;
          height: 32px;
          background: #EAEAEA;
          border-radius: 100px 20px 0px 100px;
          text-align: center;
          font-weight: 500;
          color: #333;
          font-size: 20px;
        }
      }
      .botton {
        color: #999;
        margin-top: 5px;
        font-size: 20px;
      }
    }
    .pick_goods_code {
      margin-top: 20px;
      .top {
        font-size: 24px;
        color: #666666;
      }
      .botton {
        color: #999;
        margin-top: 5px;
        font-size: 20px;
      }
    }
  }
  .address_heg {
    // border-top: 1px solid #f2f2f2;
  }
  .address_top {
    // border-top-left-radius: 10px;
    // border-top-right-radius: 10px;
    border-radius:10px
  }
  .address_bottom {
    // border-bottom-left-radius: 10px;
    // border-bottom-right-radius: 10px;
       border-radius:10px
  }
  .red {
    color: #ed3939 !important;
    font-size: 26px;
    padding-top: 10px;
  }
  .flex_wrap {
    display: flex;
    align-items: center;
  }
  .flex-center{
    justify-content: space-between;
    align-items: center;
  }
  .van-hairline--top::after {
    border-top-width: 0;
  }
  .liu0 {
    font-size: 20px;
    padding-left: 40px;
    display: flex;
    .liu1 {
      color: #666666;
    }
    .liu2 {
      color: #999999;
      width: 481px;
      margin-bottom: 20px;
    }
  }
  
  .button{
   background-color: var(--epButtonColor);
    color: var(--epTextColor);
   border: 1px solid #F8D541;
  }
}
.printModle {
  width: 545px;
  background: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-top: 30px;
  padding-left: 39px;
  padding-right: 36px;
  .info {
    font-size: 28px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 30px;
  }
  .mt10 {
    margin-bottom: 10px;
  }
  .d1 {
    .van-cell {
      padding: 0;
    }
    .van-cell::after {
      border-bottom: 0;
    }
    /deep/.van-field__label {
      color: #999999;
    }
    /deep/.van-field__control {
      border: 1px solid #dddddd;
      width: 340px;
      height: 50px;
      padding-left: 20px;
      color: #999999;
    }
    .icon {
      position: relative;
    }
    .hed_piao {
      position: relative;
      .piao {
        position: absolute;
        z-index: 1;
        right: 0;
        top: 0;
        margin-top: 13px;
        margin-right: 15px;
      }
    }
  }
  .heg {
    border: 1px solid #d8d8d8;
    margin-top: 20px;
    margin-bottom: 40px;
    margin-left: -39px;
    margin-right: -36px;
  }
  .d2 {
    .van-cell {
      padding: 0;
    }
    .van-cell::after {
      border-bottom: 0;
    }
    /deep/.van-field__label {
      color: #999999;
    }
    /deep/.van-field__control {
      width: 340px;
      height: 50px;
      padding-left: 20px;
      color: #333333;
    }
  }
}
.printFooter {
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #d8d8d8;
  margin-top: 20px;
  font-size: 28px;
  .d0 {
    text-align: center;
    height: 100px;
    line-height: 100px;
    clear: both;
    width: 100%;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    .d1 {
      color: #333333;
      border-right: 1px solid #d8d8d8;
      width: 50%;
      border-bottom-left-radius: 10px;
    }
    .d2 {
      color: #f8a651;
      width: 50%;
      border-bottom-right-radius: 10px;
      /deep/.van-button--default {
        border: 0;
        width: 100%;
        height: 100%;
        color: #f8a651;
      }
    }
  }
}
.canceldiv{
  padding: 25px;
  color: #333333;
  font-size: 24px;
  .p1{
    margin-bottom: 20px;
  }
  .p2{
    color: #999999;
    font-size: 20px;
  }
}
.index-order {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .index-order-store {
    display: flex;
    align-items: center;
  }
  .index-order-stock100-tag {
    display: flex;
    align-items: center;
    >img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    >span {
      line-height: 40px;
      font-size: 26px;
      color: #666666;
    }
  }
}
.order_page{
  position: relative;
  .zen{
    width: 64px;
    height: 32px;
    background: #E15554;
    border-radius: 4px;
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 32px;
    position: absolute;
    top: 0px;
  }

}
.shadow-page {
  
  padding: 0 30px;
}
.shop-page {
  height: 80px;
  border-bottom: 1px solid #F2F2F2;
  display: flex;
  align-items: center;
  strong {
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .shop_title {
    margin-left: 10px;
  }
}
.shadow_centent {
  position: relative;
  // width: 650px;
  height: 66px;
  // background: #FFFAE6;
  display: flex;
  align-items: center;
  // background:var(--epButtonColor);
  border-radius: 10px;
  padding: 0 24px;
  margin-top: 17px;
  border: 2px solid var(--epButtonColor);
  // opacity: .1;
  .shadow_bgc {
    // background-color: #333;
    background:var(--epButtonColor);
    opacity: .1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .shadow_name {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    width: 500px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
   
    color: var(--epTextColor);
  }
  .shadow_tag {
    position: absolute;
    width: 104px;
    height: 32px;
    font-size: 20px;
    text-align: center;
    padding: 2px 12px;
    border-radius: 0px 0px 0px 10px;
    color: var(--epTextColor);
    background: var(--epButtonColor);
    top: 0;
    right: 0;
  }
}
.print_btn {
  // width: 150px;
  // // padding: 0 27px;
  // height: 60px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // background: #FFFFFF;
  // border-radius: 32px;
  // border: 1px solid #999999;
  // font-size: 24px;
  // font-family: PingFangSC-Regular, PingFang SC;
  // font-weight: 400;
  // color: #333333;
  // // margin: 20px 0;
  // box-sizing: border-box;
  // margin-bottom: 10px;
  ::v-deep {
    .van-button__text {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &.disabled {
    background: #F2F2F2;
    color: #999999;
    // border: 1px solid #F2F2F2;

  }
  .hold_on {
    width: 32px;
    height: 32px;
    margin-left: 8px;
    animation: rotateImg 1s infinite linear;
    
  }
}
@keyframes rotateImg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.lianmdiv{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .no-product{
     font-size: 24px;
     padding: 4px 6px;
     background-color: #E15554;
     color: #fff;
     border-radius: 2px;
     margin-left: 12px;
  }
  .img{
    width:104px;
    height:36px;
  }
}
</style>
